import React from 'react';

interface ErrorMessageProps {
    message: string | undefined;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
    return (
        <p className=' text-[11px] lg:text-[13px] font-light text-[#FF0000]  appraisal-form'>{message}</p>);
};

export default ErrorMessage;
